// extracted by mini-css-extract-plugin
export default {"divider":"ff076x9v7PwEVnVB63aL","closeButton":"vKLCpLp9Q1UYcq50xBnV","tryAgainButton":"QmihTDxcygstLgEkRaXN"};